// extracted by mini-css-extract-plugin
export default {"tips":"styles_tips__HBEFv","tip":"styles_tip__zTEZu","selected":"styles_selected__3KuOS"};